import { Injectable } from '@angular/core';
import { VisitService } from './visit.service';

@Injectable({
  providedIn: 'root'
})
export class SideMenuServiceService {

  UnDoneOrders: number = 0;
  reminderedOrders : number = 0;
  getUnDoneOrdersCount() {
    this.visitService.getUnDoneOrdersCount()
      .subscribe((result: any) => {
        this.UnDoneOrders = result ? result.count : 0;
      })
  }

  getReminderedOrdersCount() {
    this.visitService.getReminderedOrdersCount()
      .subscribe((result: any) => {
        this.reminderedOrders = result ? result.count : 0;
      })
  }

  constructor(private visitService: VisitService) { }
}
